import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} StudentDetailResponse
 * @property {number} id
 * @property {string} tenant_id
 * @property {number} inst_id
 * @property {string} name
 * @property {string} username
 * @property {number} is_pswd_reset
 * @property {string} email
 * @property {string | number} age
 * @property {number} role_id
 * @property {string | number} assigned_to
 * @property {string | number} createdBy
 * @property {number | null} class_id
 * @property {string} status
 * @property {string} student_code
 * @property {Object} quiz_attempt_limit
 */

/**
 * @typedef {object} GetStudentDetailParams
 * @property {number | string} studentId - Student ID (required)
 */

/**
 * Custom hook to fetch the sutdent detail for teacher
 */
export const useGetStudentDetail = () => {
    const [student, setStudent] = useState(
    /** @type {StudentDetailResponse | null | undefined} */(undefined)
    );
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Fetch individual student details
     * @async
     * @param {GetStudentDetailParams} params
     */
    const getStudentDetail = async ({ studentId } = {}) => {

        try {
            setLoading(true);
            setError("");

            const url = `${TENANT_DOMAIN}/student/edit/${studentId}`;

            const response = await axiosInstance.get(url);

            setStudent(response?.data?.data || null);
        } catch (err) {
            setStudent(null);
            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        student,
        loading,
        error,
        getStudentDetail,
        setStudent
    };
};
